import { colors } from "@indeed/ifl-tokens/react-native";

import { DislikeButton } from "../../../../../../jobcard/components/JobCard/ActionButtons/DislikeButton";
import { Box } from "../../../../../../mads";
import { useIsSticky } from "../../../../util/useIsSticky";

type ApplySectionProps = {
  applyButton: React.ReactNode;
  secondaryButton?: React.ReactNode;
  compactSecondaryButton?: React.ReactNode;
  onPressDislike: () => void;
};

export const ApplySection = ({
  applyButton,
  secondaryButton,
  compactSecondaryButton,
  onPressDislike,
}: ApplySectionProps) => {
  const isSticky = useIsSticky();
  const hasSecondaryButton = !!compactSecondaryButton;
  const hasSecondary = !!secondaryButton;

  return (
    <Box
      sx={{
        backgroundColor: colors.background,
        gap: hasSecondary ? 8 : undefined,
        paddingBottom: 8,
        paddingLeft: 8,
        paddingTop: 8,
      }}
    >
      <Box
        sx={{
          flexDirection: "row",
          gap: hasSecondaryButton ? 8 : 16,
          alignItems: "center",
        }}
      >
        <DislikeButton onPressDislike={onPressDislike} />
        <Box sx={{ flex: 1 }}>{applyButton}</Box>
        {!!compactSecondaryButton && isSticky && compactSecondaryButton}
      </Box>
      {hasSecondary && !isSticky && secondaryButton}
    </Box>
  );
};
